module.exports = __webpack_public_path__ + "img/xinxitongji.c0616f9d.png";